<mat-label class="subHeading">Renewal Premium payment mode</mat-label>
<mat-select multiple [formControlName]="controlName" placeholder="'All'">
    <ng-container *ngFor="let paymentMode of paymentModes">
        <mat-option  [value]="paymentMode.value">{{paymentMode.name}}</mat-option>
    </ng-container>
</mat-select>